(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const updateHero = (hero) => {
      if (reduceMotion.matches || window.innerWidth < 750) {
        hero.style.setProperty('--hero-progress', '0');
        hero.dataset.act = '0';
        return;
      }

      const rect = hero.getBoundingClientRect();
      const scrollable = Math.max(1, hero.offsetHeight - window.innerHeight);
      const progress = clamp(-rect.top / scrollable, 0, 1);
      const act = progress < 0.34 ? '0' : progress < 0.68 ? '1' : '2';

      hero.style.setProperty('--hero-progress', progress.toFixed(4));
      hero.dataset.act = act;
    };

    const bindHero = (hero) => {
      if (!hero || hero.dataset.scrollyBound === 'true') return;

      hero.dataset.scrollyBound = 'true';
      let ticking = false;

      const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          updateHero(hero);
          ticking = false;
        });
      };

      updateHero(hero);
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
      reduceMotion.addEventListener?.('change', requestUpdate);
    };

    const init = (root = document) => {
      root.querySelectorAll('[data-scrolly-hero]').forEach(bindHero);
      root.querySelectorAll('.hero__mobile-gallery').forEach((gallery) => {
        if (gallery.dataset.galleryBound === 'true') return;

        const track = gallery.querySelector('.hero__mobile-track');
        const slides = Array.from(gallery.querySelectorAll('.hero__mobile-slide'));
        const dots = Array.from(gallery.querySelectorAll('.hero__mobile-gallery-dots span'));

        if (!track || slides.length === 0 || dots.length === 0) return;

        gallery.dataset.galleryBound = 'true';

        const updateDots = () => {
          const center = track.scrollLeft + (track.clientWidth / 2);
          let activeIndex = 0;
          let activeDistance = Infinity;

          slides.forEach((slide, index) => {
            const slideCenter = slide.offsetLeft + (slide.offsetWidth / 2);
            const distance = Math.abs(center - slideCenter);

            if (distance < activeDistance) {
              activeDistance = distance;
              activeIndex = index;
            }
          });

          dots.forEach((dot, index) => {
            dot.classList.toggle('is-active', index === activeIndex);
          });
        };

        track.addEventListener('scroll', updateDots, { passive: true });
        window.addEventListener('resize', updateDots, { passive: true });
        updateDots();
      });
    };

    const repairCachedHomeLinks = (root = document) => {
      const collectionPath = '/collections/all-pet-strollers';

      root.querySelectorAll('a[href]').forEach((link) => {
        const rawHref = link.getAttribute('href');

        if (!rawHref) return;

        const url = new URL(rawHref, window.location.origin);

        if (url.pathname !== '/collections/all') return;

        link.setAttribute('href', `${collectionPath}${url.search}${url.hash}`);
      });

      root.querySelectorAll('.product-card__form .product-card__quick-add').forEach((button) => {
        const card = button.closest('.product-card');
        const form = button.closest('form');
        const productLink = card?.querySelector('.product-card__media[href], .product-card__content a[href]');

        if (!form || !productLink) return;

        const link = document.createElement('a');
        link.className = 'product-card__quick-add product-card__quick-add--link';
        link.href = productLink.href;
        link.textContent = 'Check fit & price';
        form.replaceWith(link);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        init();
        repairCachedHomeLinks();
      });
    } else {
      init();
      repairCachedHomeLinks();
    }

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
      repairCachedHomeLinks(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
